export const API_URL = process.env.NEXT_PUBLIC_API_URL;
export const RECAPTCHA_SITE_KEY =
  process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY || '';
